import Card from "app/components/Card";
import { StatusIcon } from "app/components/Icons";
import React from "react";
import TicketLimit from "../TicketLimit";
import ColumnGroupActions from "../ColumnGroupActions";
import { TicketGroup } from "../../../../types";

interface GroupHeaderProps {
  group: TicketGroup;
}

const GroupHeader: React.FC<GroupHeaderProps> = ({ group }) => {
  return (
    <React.Fragment>
      <Card className="rounded-[6px] p-[10px]">
        <div className="flex flex-row items-center justify-between gap-[6px]">
          {/* Maximum call stack size exceeded at Array.forEach (<anonymous>) */}
          <div className="flex flex-row items-center gap-[6px]">
            <div className="flex items-center justify-center">
              <StatusIcon size={15} color={group?.color} />
            </div>
            <p
              style={{ color: group?.color }}
              className="font-medium text-sm leading-[21px] mb-0 mt-[2px] text-nowrap text-black"
            >
              {group?.groupName}
            </p>
            <TicketLimit
              groupStatus={group}
              count={group?.tickets?.length}
              maxCount={group?.ticketLimit}
            />
          </div>
          <ColumnGroupActions group={group} />
        </div>
      </Card>
    </React.Fragment>
  );
};

export default GroupHeader;
